<template>
  <!-- 展商端主布局：深蓝色侧边栏 + 白色头部 + 内容区 -->
  <el-container class="manage-layout">
    <!-- 深蓝色侧边栏导航 -->
    <el-aside class="manage-sidebar">
      <!-- 侧边栏顶部标题 -->
      <div class="sidebar-title">展商业务端</div>
      <!-- 可滚动的菜单区域 -->
      <el-scrollbar wrap-class="scrollbar-wrapper">
        <el-menu
          :default-active="activeMenu"
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409eff"
          router
        >
          <el-menu-item index="1" route="/manage/index" class="sidebar-item">
            首页
          </el-menu-item>
          <el-menu-item index="2" route="/manage/infolist" class="sidebar-item">
            展商信息
          </el-menu-item>
          <el-menu-item index="9" route="/manage/ex_user" class="sidebar-item">
            参展人员
          </el-menu-item>
          <el-menu-item index="3" route="/manage/productlist" class="sidebar-item">
            参展商品
          </el-menu-item>
          <el-menu-item index="4" route="/manage/reservelist" class="sidebar-item">
            预约客户
          </el-menu-item>
          <el-menu-item index="8" route="/manage/hitlist" class="sidebar-item">
            点赞用户
          </el-menu-item>
          <el-menu-item index="6" route="/manage/downloadlist" class="sidebar-item">
            资料下载
          </el-menu-item>
          <el-menu-item index="7" route="/manage/exhibitionlist" class="sidebar-item">
            展会信息
          </el-menu-item>
        </el-menu>
      </el-scrollbar>
    </el-aside>

    <!-- 右侧：头部 + 内容 -->
    <el-container class="manage-right">
      <!-- 顶部头部 -->
      <el-header class="manage-header">
        <div class="manage-header__inner">
          <div></div>
          <div class="manage-header__user">
            <el-dropdown trigger="click">
              <span class="manage-header__username">
                {{ name }}
                <i class="el-icon-arrow-down"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div @click="goOpinion">意见反馈</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="goPassword">修改密码</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="LogOut">退出登录</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-header>

      <!-- 内容区域 -->
      <el-main class="manage-main">
        <router-view :include="path"></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: "Manage",
  data() {
    return {
      /** 缓存的路由名称，用于 keep-alive */
      path: this.$route.name,
      /** 当前用户名 */
      name: localStorage.getItem("name"),
    };
  },
  computed: {
    /** 当前激活的菜单项索引，根据路由路径前缀匹配 */
    activeMenu() {
      const path = this.$route.path;
      const routeMap = [
        { prefix: '/manage/index', index: '1' },
        { prefix: '/manage/infolist', index: '2' },
        { prefix: '/manage/infodetail', index: '2' },
        { prefix: '/manage/ex_user', index: '9' },
        { prefix: '/manage/productlist', index: '3' },
        { prefix: '/manage/productdetail', index: '3' },
        { prefix: '/manage/productadd', index: '3' },
        { prefix: '/manage/reservelist', index: '4' },
        { prefix: '/manage/hitlist', index: '8' },
        { prefix: '/manage/downloadlist', index: '6' },
        { prefix: '/manage/exhibitionlist', index: '7' },
        { prefix: '/manage/exhibitiondetail', index: '7' },
      ];
      const match = routeMap.find(r => path.startsWith(r.prefix));
      return match ? match.index : '1';
    }
  },
  created() {
    document.title = "展商后台-云伴展";
  },
  methods: {
    /**
     * 跳转到意见反馈页
     */
    goOpinion() {
      this.$router.push({ name: "opinion" });
    },

    /**
     * 跳转到修改密码页
     */
    goPassword() {
      this.$router.push({ name: "password" });
    },

    /**
     * 退出登录
     * 弹出确认框，确认后清除 Token 并跳转到登录页
     */
    LogOut() {
      this.$confirm("将退出登录，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("userid");
        localStorage.removeItem("name");
        this.$message({ message: "退出成功", type: "success" });
        this.$router.push({ name: "manageLogin" });
      });
    },
  },
};
</script>

<style scoped>
/* 整体布局 */
.manage-layout {
  min-height: 100%;
  height: 100vh;
}

/* 右侧容器（头部 + 内容） */
.manage-right {
  flex-direction: column;
  min-width: 0;
}

/* 深蓝色侧边栏（vue-element-admin 风格） */
.manage-sidebar {
  width: 210px !important;
  background-color: #304156;
  overflow: hidden;
  height: 100vh;
  padding: 0 !important;
  box-sizing: border-box;
}

::v-deep .el-aside {
  padding: 0 !important;
}

/* 侧边栏顶部标题 */
.sidebar-title {
  width: 210px;
  max-width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
  background-color: #304156;
  letter-spacing: 1px;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
}

/* 侧边栏滚动区域高度 */
.manage-sidebar .el-scrollbar {
  height: calc(100vh - 50px);
}

/* 顶部头部 */
.manage-header {
  height: var(--header-height, 60px) !important;
  line-height: var(--header-height, 60px);
  padding: 0;
  background-color: var(--header-bg, #ffffff);
  border-bottom: 1px solid var(--header-border, #e2e8f0);
  display: flex;
  align-items: center;
}

.manage-header__inner {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.manage-header__user {
  padding-right: var(--spacing-lg, 24px);
}

.manage-header__username {
  font-size: 14px;
  color: var(--text-secondary, #64748b);
  cursor: pointer;
}

/* 侧边栏菜单项 */
.sidebar-item {
  height: 56px;
  line-height: 56px;
}

/* 侧边栏激活态 */
::v-deep .el-menu-item.is-active {
  background-color: #263445 !important;
}

/* 移除菜单右侧留白 */
::v-deep .el-menu {
  border-right: none;
  padding-right: 0;
}

/* 滚动条容器去除右侧间隙 */
::v-deep .el-scrollbar__wrap {
  margin-right: 0 !important;
  overflow-x: hidden !important;
}

/* 内容区域 */
.manage-main {
  padding: 0;
  background-color: var(--content-bg, #f1f5f9);
  overflow: auto;
}

.el-container {
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Manage.vue